import React, { useState } from "react";

const OptimizedImage = ({
    src,
    alt,
    width,
    height,
    className = "",
    placeholder = "/placeholder.png",
    fallback = "/fallback.png",
    webpSrc,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const handleLoad = () => setLoaded(true);
    const handleError = () => setError(true);

    return (
        <div >
            <picture>
                {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
                <img
                    src={error ? fallback : src}
                    alt={alt}
                    width={width}
                    height={height}
                    loading="lazy"
                    decoding="async"
                    onLoad={handleLoad}
                    onError={handleError}
                    className={className}
                />
            </picture>
        </div>
    );
};

export default OptimizedImage;
